/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Drawer, DrawerContent, DrawerTitle, DrawerDescription } from '@whitbread-eos/atoms/ui';
import { getPathForLocale } from '@whitbread-eos/utils';
import { getLocaleByPathname, useTranslation, formatIBAssetsUrl } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import { useSearchParams, usePathname } from 'next/navigation';
import { useState } from 'react';
import SidebarLink from '../SidebarLink/SidebarLink.component';
const ThirdLevelNavMobile = ({ icons, toggleSecondLevel })=>{
    const pathname = usePathname();
    const locale = getLocaleByPathname(pathname);
    const { t } = useTranslation([
        'common',
        'cards'
    ]);
    const searchParams = useSearchParams();
    const tabParam = searchParams.get('tab');
    const [isOpen, setIsOpen] = useState(false);
    const handleBack = ()=>{
        setIsOpen(false);
        toggleSecondLevel();
    };
    const handleToggle = ()=>{
        setIsOpen(!isOpen);
    };
    const getCurrentThirdLevelLabel = ()=>{
        if (pathname.includes('manage/cards')) {
            if (tabParam === 'centrally-stored') {
                return 'cards.cardMgmt.tabs.centrallyStored';
            } else if (tabParam === 'innbusiness-pay') {
                return 'cards.cardMgmt.tabs.innBusinessPay';
            }
            return 'cards.cardMgmt.tabs.centrallyStored';
        }
        return 'common.layout.menu.manage.label';
    };
    const manageEmployeesOptions = ()=>{
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SidebarLink, {
                    label: 'Inn Business',
                    isActive: tabParam === 'innbusiness' || tabParam === null,
                    href: getPathForLocale(locale, 'manage/employees'),
                    testId: "Manage-Employees-Inn-Business",
                    onClick: handleToggle
                }),
                /*#__PURE__*/ _jsx(SidebarLink, {
                    label: 'InnBusiness Pay',
                    isActive: tabParam === 'innbusiness-pay',
                    href: getPathForLocale(locale, 'manage/employees?tab=innbusiness-pay'),
                    testId: "Manage-Employees-Inn-Business-Pay",
                    onClick: handleToggle
                })
            ]
        });
    };
    const manageCardsOptions = ()=>{
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(SidebarLink, {
                    label: t('cards.cardMgmt.tabs.centrallyStored'),
                    isActive: tabParam === 'centrally-stored' || tabParam === null,
                    href: getPathForLocale(locale, 'manage/cards'),
                    testId: "Manage-Cards-Inn-Business",
                    onClick: handleToggle
                }),
                /*#__PURE__*/ _jsx(SidebarLink, {
                    label: t('cards.cardMgmt.tabs.innBusinessPay'),
                    isActive: tabParam === 'innbusiness-pay',
                    href: getPathForLocale(locale, 'manage/cards?tab=innbusiness-pay'),
                    testId: "Manage-Cards-Inn-Business-Pay",
                    onClick: handleToggle
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": "Mobile-Nav-Third-Level-Container",
                children: !isOpen && /*#__PURE__*/ _jsxs("div", {
                    "data-testid": "Mobile-Nav-activeLinkThirdLevel",
                    className: activeLinkStyle,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            children: t(getCurrentThirdLevelLabel())
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            className: `${thirdLevelToggleStyle} ${openButtonStyle}`,
                            onClick: ()=>handleToggle(),
                            "data-testid": "Third-Level-Expand-Button",
                            children: /*#__PURE__*/ _jsx(Image, {
                                alt: "expand third level icon",
                                src: formatIBAssetsUrl(icons['icon.chevron.up.purple']),
                                width: 24,
                                height: 24
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Drawer, {
                open: isOpen,
                onOpenChange: setIsOpen,
                children: /*#__PURE__*/ _jsxs(DrawerContent, {
                    hasCloseButton: false,
                    className: 'p-0 mt-0',
                    children: [
                        /*#__PURE__*/ _jsx(DrawerTitle, {
                            className: drawerTitleStyle,
                            children: 'Navigation Menu'
                        }),
                        /*#__PURE__*/ _jsx(DrawerDescription, {
                            className: drawerTitleStyle,
                            children: 'Navigation Menu'
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            "data-testid": "Third-Level-Drawer",
                            className: thirdLevelDrawerStyle,
                            children: [
                                /*#__PURE__*/ _jsx("button", {
                                    className: `${thirdLevelToggleStyle} ${closeButtonStyle}`,
                                    onClick: ()=>handleToggle(),
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "collpase third level icon",
                                        src: formatIBAssetsUrl(icons['icon.chevron.down.purple']),
                                        width: 24,
                                        height: 24
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("button", {
                                    onClick: ()=>handleBack(),
                                    className: backButtonStyle,
                                    children: [
                                        /*#__PURE__*/ _jsx(Image, {
                                            width: 24,
                                            height: 24,
                                            src: formatIBAssetsUrl(icons['icon.chevron.left.purple']),
                                            alt: "back icon"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: backButtonTextStyle,
                                            children: "Back to Manage"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: linksContainerStyle,
                                    children: [
                                        pathname.includes('manage/employees') && manageEmployeesOptions(),
                                        pathname.includes('manage/cards') && manageCardsOptions()
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default ThirdLevelNavMobile;
const activeLinkStyle = 'flex text-primaryColor items-center text-sm font-bold rounded-lg bg-lightGrey5 hover:border-lightGrey4 p-2 mb-2';
const thirdLevelDrawerStyle = 'px-4 pb-6 pt-20';
const linksContainerStyle = 'flex flex-col gap-2';
const closeButtonStyle = 'absolute right-6 top-4';
const openButtonStyle = 'ml-auto';
const thirdLevelToggleStyle = 'flex shrink-0 justify-center items-center w-8 h-8 ml-auto rounded-full border border-lightGrey3 bottom-28 -right-4 bg-baseWhite cursor-pointer hover:bg-lightGrey4 active:bg-toggleButtonPressed';
const backButtonStyle = 'flex text-secondaryColor mb-6';
const backButtonTextStyle = 'ml-2 font-semibold';
const drawerTitleStyle = 'hidden';
